export enum SLOTH_TYPE {
    SLEEP = "sleep",
    WIN = "win",
    RELAX = "relax",
    WORK = "work",
    QUESTION = "question",
    BROKEN = "broken"
}